module.exports = __webpack_public_path__ + "static/Hind-Regular-dc2874ab4f42fb0a99fe02d60491c133.ttf";